// extracted by mini-css-extract-plugin
module.exports = {"nav":"Snapshot_nav__1BKuD","item":"Snapshot_item__Nleme","active":"Snapshot_active__3Fh6G"};